var baseRoute = '/'

var childRoutes = {
    home: '',
    link_bcard: 'card/link',
    member_update_contact: 'member/update_contact',
    member_profile: 'member/profile',
    member_change_password: 'member/change_password',
    member_forgot_password: 'member/forgot_password',
    request_pin_reset: 'card/request_reset_pin',
    member_points_convert: 'exchange/send',
    payment_complete: 'payment/payment_complete',
    payment_payment_detail: 'payment/payment_payment_detail',
    redeem_bpoints: 'redeem_bpoints',
    my_vouchers: 'member/my_vouchers',
    payment_signature: 'payment/payment_signature',
    apply_promo_codes: 'payment/apply_promo_codes',
    search_promo_codes: 'payment/search_promo_codes',
    search_promo_codes_multiple: 'payment/search_promo_codes_multiple',
    partner_profile: 'partners/profile',
    prepaid_topup: 'topup/send',
    partner_change_password: 'partners/change_password',
    partner_login: 'partners/partner_login',
    admin_login: 'nova',

};

var routes = [];
for (var key in childRoutes) {
    routes[key] = baseRoute + childRoutes[key];
}

export default {
    ...routes
}
